/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type HTMLAttributes, createContext, forwardRef } from 'react';
import { type ContextValue, Provider, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';
import { mergeStyles } from '../../utils/merge-styles/merge-styles.util';
import { ImageContext } from '../image/image.component';
import { ViewContext } from '../view/view.component';

interface MediaTileProps extends Omit<HTMLAttributes<HTMLDivElement>, 'style' | 'className'> {
  variant?: keyof typeof variantVariants;
  style?: stylex.StyleXStyles;
}

const MediaTileContext = createContext<ContextValue<MediaTileProps, HTMLDivElement>>({});

const MediaTile = forwardRef(({ style: styleProp, ...mergedProps }: MediaTileProps, ref: ForwardedRef<HTMLDivElement>) => {
  [mergedProps, ref] = useContextProps(mergedProps, ref, MediaTileContext);

  const { style: contextStyle, children, variant = "contain", ...coreProps } = mergedProps as MediaTileProps;

  return (
    <div ref={ref} {...stylex.props(styles.base, mergeStyles(contextStyle, styleProp))} {...coreProps}>
      <Provider values={[
        [ImageContext, {
          style: [imageStyles.base, variantVariants[variant]],
          src: '',
        }],
        [ViewContext, { style: viewStyles.base }],
      ]}>
        {children}
      </Provider>
    </div>
  );
});

const styles = stylex.create({
  base: {
    borderRadius: 10,
    overflow: 'hidden',
    placeItems: 'center',
    backgroundColor: $.surfaceBGSecondary,
    display: 'grid',
    position: 'relative',
    minHeight: 80,
    minWidth: 80,
  },
});

const variantVariants = stylex.create({
  cover: { objectFit: 'cover' },
  contain: { objectFit: 'contain' }
});

const imageStyles = stylex.create({
  base: {
    inset: 0,
    position: 'absolute',
    height: '100%',
    width: '100%',
  }
});

const viewStyles = stylex.create({
  base: {
    inset: 0,
    margin: 'auto',
    placeItems: 'center',
    display: 'grid',
    position: 'absolute',
    zIndex: 1,
  }
});

export { MediaTile, MediaTileContext, type MediaTileProps };
